import { useState } from 'react';
import { getFileById } from '../api/generated/file-controller/file-controller.ts';
import { FileDetailsDto } from '../api/generated/model';
import { base64ToBlob, getMimeTypeFromFileExtension } from '../utils/file.ts';

export function useOpenFile() {
  const [isFileLoading, setIsFileLoading] = useState(false);

  const openFile = async (fileDetails: FileDetailsDto | undefined) => {
    if (!fileDetails?.id) return;
    setIsFileLoading(true);
    try {
      const data = await getFileById(fileDetails.id);
      const blob = base64ToBlob(data.file, getMimeTypeFromFileExtension(fileDetails.fileName));
      const objectUrl = URL.createObjectURL(blob);
      window.open(objectUrl, '_blank');
      URL.revokeObjectURL(objectUrl);
    } finally {
      setIsFileLoading(false);
    }
    return fileDetails.id;
  };

  return { isFileLoading, openFile };
}
